<script>
  import Avatar from '@components/Avatar.svelte';
  import Modal from '@components/Modal.svelte';
  import Track from '@utils/track';
  import tippy from 'tippy.js';
  import { goto } from '$app/navigation';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import CreatorSpotlightModal from '@app-components/modal/CreatorSpotlightModal.svelte';
  import CookieHelper from '@utils/cookie-helper';

  export let group;
  export let rec;
  export let recObject;
  export let authors = [];
  export let condensedView = false;

  export let maxShown = 3;
  export let avatarSize = 25;
  export let mobile = false;
  export let showContributorModal = true;
  export let showContributorButton = true;
  export let disableHyperlink = false;
  export let contributorText = '[count] contributors';
  export let skipBy = false;
  export let showNames = true;
  export let showContributorsTippyLabel = false;
  export let nameMaxLinesShown = null;

  let adminAuthors = [];
  let contributorAuthors = [];
  let visibleAuthors = [];
  let currentUser = getCurrentUserStore('default');
  let selectedAuthor = {};
  let showCreatorSpotlightModal = false;

  $: if (authors) {
    authors = authors.filter((x) => x.role === 'admin' || x.role === 'contributor');

    adminAuthors = authors && authors.filter((a) => a.role === 'admin');
    contributorAuthors = authors && authors.filter((a) => a.role === 'contributor');
    visibleAuthors = authors.slice(0, maxShown);
  }

  let showContributorModalInternal = false;

  let showContributors = function () {
    showContributorModalInternal = true;
  };

  let setupTippy = function (node, authors) {
    let instance;

    if (showContributorsTippyLabel) {
      var content = '';
      authors.forEach((u) => {
        content += `${u.name}<br />`;
      });

      instance = tippy(node, {
        allowHTML: true,
        content: content,
      });
    }

    return {
      destroy() {
        if (instance) {
          instance.destroy();
        }
      },
    };
  };

  let trackClicked = function (author) {
    return Track.userNameClicked({
      user: author,
      group,
      rec,
      recObject,
      currentUser: currentUser,
    });
  };

  export let handleAvatarClicked = async function (author) {
    await trackClicked(author);
    goto(author.profile_path);
  };

  export let handleNameClicked = async function (author) {
    await trackClicked(author);
    if (CookieHelper.allowSpotlightModalFlow(author) && (currentUser?.id != author.id)) {
      selectedAuthor = author;
      showCreatorSpotlightModal = true;
      CookieHelper.setSpotlightVisitsCookie(author);
    } else {
      goto(author.profile_path);
    }
  };
</script>

<style style="text/scss" lang="scss">
  a {
    color: #000;
  }

  .list-author {
    display: flex;
    align-items: center;
    font-size: 15px;
    width: 100%;
    &.welcome-note-active {
      width: max-content;
      margin-right: 16px;
    }

    .by {
      margin-right: 12px;
      opacity: 0.5;
      // padding-bottom: 2px;
    }

    .list-author-name {
      opacity: 0.5;
      cursor: pointer;

      &:hover {
        opacity: 1;
        color: #a893f9;
      }
    }

    .avatar {
      display: inline-block;
      margin-right: 12px;
      width: 25px;
      height: 25px;
    }

    .multiple-avatar {
      display: inline-block;
      margin-right: 8px;
      width: 25px;
      height: 25px;

      :global(.avatar-border) {
        border: 1px solid #f5f3fc !important;
      }
    }

    .contributors {
      margin-left: 7px;
      opacity: 0.5;
      padding-bottom: 3px;
      cursor: pointer;

      &.condensedView {
        margin-left: 0px;
        opacity: 1;
        padding-bottom: 0px;
        z-index: 2;

        > .contributor-count {
          background-color: #eae4ff;
          color: #a893f9;
          border-radius: 50px;
          font-weight: 500;
          font-size: 12px;
          height: 25px;
          min-width: 25px;
          width: auto;
          padding: 0 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 200;
          border: 2px solid rgb(236, 236, 236);
        }
      }
    }
  }
</style>

{#if showCreatorSpotlightModal}
  <CreatorSpotlightModal
    mobile={mobile}
    user={selectedAuthor}
    bind:showModal={showCreatorSpotlightModal}
    on:close={() => {
      showCreatorSpotlightModal = false;
    }} />
{/if}

{#if showContributorModal}
  <div class="svelte-modal">
    <Modal
      mobile={mobile}
      on:close={() => {
        showContributorModalInternal = false;
      }}
      show={showContributorModalInternal}>
      <div slot="header">List Creators ({adminAuthors.length})</div>

      <div slot="content">
        <div>
          {#each adminAuthors as author}
            <div style="display: flex; margin-bottom: 20px;">
              <span
                on:click|preventDefault|stopPropagation={() => {
                  handleAvatarClicked(author);
                }}>
                <Avatar width={22} src={author.avatar_url} user={author} mobile={mobile} />
              </span>
              <div style="margin-left: 15px">
                <AccountVerifiedIcon
                  dimension={12}
                  verified={author.verified}
                  clickable={true}
                  on:areaClicked={() => handleNameClicked(author)}>
                  <svelte:fragment slot="account-name">
                    <a
                      on:click|preventDefault|stopPropagation={() => {
                        handleNameClicked(author);
                      }}
                      href={author.profile_path}>
                      {author.name}
                      {#if author.education}
                        <span style="opacity: 0.5; font-size: 13px; margin-left: 5px;">
                          ({[author.education.degree, author.education.class_year]
                            .filter((x) => x != '' && x != null && x != undefined)
                            .join(' - ')})
                        </span>
                      {/if}
                    </a>
                  </svelte:fragment>
                </AccountVerifiedIcon>
              </div>
            </div>
          {/each}
        </div>

        {#if contributorAuthors && contributorAuthors.length > 0}
          <div
            style="font-weight: 600; font-size: 18px; line-height: 24px; color:
          black; margin-top: 50px; margin-bottom: 30px">
            List Contributors ({contributorAuthors.length})
          </div>

          {#each contributorAuthors as author}
            <div style="display: flex; margin-bottom: 20px;">
              <span
                on:click|preventDefault|stopPropagation={() => {
                  handleAvatarClicked(author);
                }}>
                <Avatar width={22} src={author.avatar_url} user={author} mobile={mobile} />
              </span>
              <div style="margin-left: 15px">
                <a
                  on:click|preventDefault|stopPropagation={() => {
                    handleNameClicked(author);
                  }}
                  href={author.profile_path}>
                  {author.name}
                  {#if author.education}
                    <span style="opacity: 0.5; font-size: 13px; margin-left: 5px;">
                      ({[author.education.degree, author.education.class_year]
                        .filter((x) => x != '' && x != null && x != undefined)
                        .join(' - ')})
                    </span>
                  {/if}
                </a>
              </div>
            </div>
          {/each}
        {/if}
      </div>
    </Modal>
  </div>
{/if}

{#if !condensedView}
  <div class="list-author" class:welcome-note-active={mobile}>
    {#if !skipBy}
      <div class="by">By</div>
    {/if}
    {#if authors.length == 1}
      <div class="avatar">
        {#if !disableHyperlink || !CookieHelper.allowSpotlightModalFlow(authors[0])}
          <a
            href={authors[0].profile_path}
            on:click|preventDefault|stopPropagation={() => {
              handleAvatarClicked(authors[0]);
            }}>
            <Avatar width={avatarSize} src={authors[0].avatar_url} user={authors[0]} mobile={mobile} forceCursor={true} showSpotlightRingOnly={currentUser?.id == authors[0].id && authors[0].spotlight_active}/>
          </a>
        {:else}
          <Avatar width={avatarSize} src={authors[0].avatar_url} user={authors[0]} forceCursor={true} mobile={mobile} showSpotlightRingOnly={currentUser?.id == authors[0].id && authors[0].spotlight_active}/>
        {/if}
      </div>
      {#if showNames}
        {#if !disableHyperlink}
          <AccountVerifiedIcon
            dimension={12}
            verified={authors[0].verified}
            clickable={true}
            on:areaClicked={() => handleNameClicked(authors[0])}>
            <svelte:fragment slot="account-name">
              <a
                href={authors[0].profile_path}
                on:click|preventDefault|stopPropagation={() => {
                  handleNameClicked(authors[0]);
                }}
                class="list-author-name"
                style={nameMaxLinesShown
                  ? `display: -webkit-box; -webkit-line-clamp: ${nameMaxLinesShown}; -webkit-box-orient: vertical; text-overflow: ellipsis; overflow: hidden;`
                  : ''}>
                {authors[0].name}
              </a>
            </svelte:fragment>
          </AccountVerifiedIcon>
        {:else}
          <AccountVerifiedIcon
            dimension={12}
            verified={authors[0].verified}
            clickable={true}
            on:areaClicked={() => handleNameClicked(authors[0])}>
            <svelte:fragment slot="account-name">
              <span
                style={nameMaxLinesShown
                  ? `display: -webkit-box; -webkit-line-clamp: ${nameMaxLinesShown}; -webkit-box-orient: vertical; text-overflow: ellipsis; overflow: hidden; opacity: 0.5;`
                  : ''}>{authors[0].name}</span>
            </svelte:fragment>
          </AccountVerifiedIcon>
        {/if}
      {/if}
    {/if}

    {#if authors.length > 1}
      {#each visibleAuthors as author}
        <div class="multiple-avatar">
          {#if !disableHyperlink || !author.spotlight_active}
            <a
              href={author.profile_path}
              on:click|preventDefault|stopPropagation={() => {
                handleAvatarClicked(author);
              }}>
              <Avatar tooltip={author.name} width={avatarSize} src={author.avatar_url} user={author} mobile={mobile} />
            </a>
          {:else}
            <Avatar tooltip={author.name} width={avatarSize} src={author.avatar_url} user={author} mobile={mobile} />
          {/if}
        </div>
      {/each}
      {#if showContributorButton && visibleAuthors.length < authors.length}
        <div
          use:setupTippy={authors.filter((x) => visibleAuthors.indexOf(x) == -1)}
          class="contributors"
          on:click|preventDefault|stopPropagation={showContributors}>
          {contributorText.replace('[remainingCount]', authors.length - maxShown).replace('[count]', authors.length)}
        </div>
      {/if}
    {/if}
  </div>
{:else}
  <div class="list-author">
    {#if authors.length > 1}
      {#each visibleAuthors as author}
        <div class="multiple-avatar" style="margin-right: -12px;">
          {#if !disableHyperlink || !author.spotlight_active}
            <a
              href={author.profile_path}
              on:click|preventDefault|stopPropagation={() => {
                handleAvatarClicked(author);
              }}>
              <Avatar
                tooltip={author.name}
                width={avatarSize}
                src={author.avatar_url}
                showBorder={true}
                mobile={mobile}
                user={author} />
            </a>
          {:else}
            <Avatar
              tooltip={author.name}
              width={avatarSize}
              src={author.avatar_url}
              showBorder={true}
              user={author}
              mobile={mobile} />
          {/if}
        </div>
      {/each}
      {#if showContributorButton && visibleAuthors.length < authors.length}
        <div
          use:setupTippy={authors.filter((x) => visibleAuthors.indexOf(x) == -1)}
          class="contributors"
          class:condensedView={condensedView}
          on:click|preventDefault|stopPropagation={showContributors}>
          <div class="contributor-count">
            {contributorText.replace('[remainingCount]', authors.length - maxShown).replace('[count]', authors.length)}
          </div>
        </div>
      {/if}
    {/if}
  </div>
{/if}
